// Compose
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { withStyles } from '@material-ui/core/styles'
import { theme, colors } from '../../../theme/Global/index'

// Component pieces
import mapStateToProps from './mapStateToProps'
import renderer from './renderer'

const MainToolBarComponent = compose(
  connect(mapStateToProps),
  withStyles(() => ({
    buttonStyle: {},
    companyLogoHeader: {
      display: 'flex',
      alignItems: 'center'
    },
    toolbar: {
      backgroundColor: colors.govDocsBlue,
      color: theme.colors.whiteText,
      minHeight: '6.5rem',
      padding: 0
    }
  }))
)(renderer)

export default MainToolBarComponent
